import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'li3-checkbox-form-item',
  templateUrl: './checkbox-form-item.component.html',
  styleUrls: ['./checkbox-form-item.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CheckboxFormItemComponent)
    }
  ]
})

export class CheckboxFormItemComponent implements OnInit, ControlValueAccessor {
  @Input() frmGroup: FormGroup;
  @Input() isChecked: boolean;
  @Input() title: string;
  @Input() tooltip: string;
  @Input() testId: string;

  constructor() { }

  ngOnInit() {
  }

  propagateChange = function (_: any) {
  };

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
  }

  writeValue(value: boolean) {
  }

  onChange(value) {
    this.propagateChange(value);
  }
}
